import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  namespace: 'AMENITY',
  entryPoint: '/amenities',
  collectionName: 'amenities',
  querySearchListing: [
    ['name'],
    { order: { id: 'asc' } }
  ],
  successMessageCreate: 'Amenity created',
  successMessageUpdate: 'Amenity updated',
  successMessageDelete: 'Amenity deleted',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/amenity/triggers.js